var usernameSetting = "webclient.login.username",
    agreeSetting = "webclient.login.hasagreed",
    agreeSettingExp = "webclient.login.agreeexp";

window.addEvent("load", function() {
    initialize();
});

initialize = function() {
    loadConfig();
    setupLoginForm();
    setupChangePassForm();
    setupForgotPass();
    setupUserAgreement();

    var ssoLoginButton = $("ssoLoginButton");
    if (ssoLoginButton)
        ssoLoginButton.addOnClick(Librarian.authHandler.getSamlRequest);

    var copyrightYearEl = $("copyrightYear");
    if (copyrightYearEl)
        copyrightYearEl.set("text", new Date().getFullYear());

    if (Librarian.profile.enforcePasswordComplexity) {
        getPasswordComplexityRules();
    }

    if (Librarian.features.metroui.load) {
        var buttonEls = $$("input[type=button]");
        for (var i = buttonEls.length; i--;)
            buttonEls[i].addClass("pure-button pure-button-primary");
    }
};

loadConfig = function() {
    if (Librarian.features.config.load) {
        Librarian.Config.load(function() {
            $(document.body).show();
        });
    }
    else {
        $(document.body).show();
    }
}

// #region Login

setupLoginForm = function() {
    var loginFormEl = $("loginForm");
    if (loginFormEl) {
        loginFormEl.reset();

        var savedUsername = Librarian.Utils.getUserSetting(usernameSetting);
        if (savedUsername) {
            // Set the email value
            loginFormEl.email.value = savedUsername;
            // Check the remember box
            loginFormEl.saveinfo.checked = true;
            // Focus on the password box
            if (loginFormEl.password && $(loginFormEl.password).isVisible())
                loginFormEl.password.focus();
        }
        // Otherwise focus on the email box
        else if (loginFormEl.email && $(loginFormEl.email).isVisible())
            loginFormEl.email.focus();

        loginFormEl.addOnKeyPress("enter", onSubmit);
    }

    var itemEl = $("submitButton");
    if (itemEl) {
        itemEl.addOnClick(onSubmit);
    }
}

onSubmit = function(e) {
    e.preventDefault();

    var loginFormEl = $("loginForm");
    if (loginFormEl.hasClass("disabled"))
        return;

    clearErrors();

    var itemEl = $("resetPassPanel");
    if (itemEl)
        itemEl.hide();

    if (!loginFormEl.email.value || !loginFormEl.password.value) {
        toggleError("passError", true);
        return;
    }

    if (loginFormEl.saveinfo.checked) 
        Librarian.Utils.setUserSetting(usernameSetting, loginFormEl.email.value);
    else
        Librarian.Utils.deleteUserSetting(usernameSetting);

    disableForm(loginFormEl, true);

    logon();
};

logon = function(params) {
    var credentials = getCredentials();

    var session = new Librarian.Session();
    session.onLogon = onLogonSuccess;
    session.onFailure = onLogonFailure;

    session.logon(credentials.username, credentials.password, params);
};

getCredentials = function() {
    var loginFormEl = $("loginForm");

    return {
        username: loginFormEl.email.value, 
        password: loginFormEl.password.value
    };
}

onLogonSuccess = function(sessionInfo) {
    var changePassEl = $("changePassPanel"),
        complexityEl = $("passComplexity"),
        passRequirementsEl = $("passwordRequirementsWrapper");

    if (sessionInfo.UserInfo.LoginMask == 1) {
        if (changePassEl)
            changePassEl.show();

        if (complexityEl)
            complexityEl.show();

        if (passRequirementsEl)
            passRequirementsEl.show();

        return;
    }

    if (changePassEl) 
        changePassEl.hide();

    if (complexityEl)
        itemEl.hide();

    loadLibraryPage();
};

onLogonFailure = function(xhr) {
    if (Librarian.Session.isMfaRequired(xhr)) {
        handleMFA(xhr.responseText);
        return;
    }
    else if (xhr.status == 401)
        toggleError("passError", true);
    else
        Librarian.Utils.error(xhr.responseText);

    var itemEl = $("changePassPanel");
    if (itemEl)
        itemEl.hide();

    itemEl = $("passComplexity");
    if (itemEl)
        itemEl.hide();

    disableForm("loginForm", false);
};

loadLibraryPage = function(forceAgree) {
    if (!checkUserAgreement(forceAgree))
        return;

    var url = "library.htm?" + Librarian.buildVersion + window.location.hash;

    window.open(url, "_self");
};

// #endregion

// #region MFA

handleMFA = function(responseText) {
    var mfaInfo = JSON.parse(responseText);
    var credentials = getCredentials();

    var container = $("loginMfaContainer");
    if (container)
        return;

    var loginPanel = document.getElement(".loginpanel");

    container = new Element("div", {
        id: "loginMfaContainer"
    }).inject(loginPanel);

    var mfaPanel = new Librarian.Session.MFAPanel({
        container: container,
        mfaInfo: mfaInfo,
        credentials: credentials,
        onSuccess: onMfaSuccess
    });
};

onMfaSuccess = function(sessionInfo) {
    var container = $("loginMfaContainer");
    if (container)
        container.hide();

    onLogonSuccess(sessionInfo);
}

// #endregion

// #region Update Password

setupChangePassForm = function() {
    var changePassFormEl = $("changePassForm");
    if (changePassFormEl) {
        changePassFormEl.reset();

        changePassFormEl.addOnKeyPress("enter", updateUserInfo);
    }

    var itemEl = $("updateButton");
    if (itemEl) {
        itemEl.addOnClick(updateUserInfo);
    }
}

updateUserInfo = function(e) {
    e.preventDefault();

    var changePassFormEl = $("changePassForm");
    if (changePassFormEl.hasClass("disabled"))
        return;

    var updatePasswordEl = $("newPass"),
        updatePassword2El = $("newPassConfirm"),
        itemEl = $("resetPassPanel");
    if (itemEl)
        itemEl.hide();

    itemEl = $("passComplexity");
    if (itemEl)
        itemEl.hide();

    clearErrors();

    var updateErrorEl = $("newPassError");
    // If passwords are empty, show error message
    if ((updatePasswordEl.value.length == 0) || (updatePassword2El.value.length == 0)) {
        if (updateErrorEl)
            updateErrorEl.show("table-row");
        return;
    }
    if (updateErrorEl)
        updateErrorEl.hide();

    updateErrorEl = $("passMatchError");
    // Compare passwords and show error if no match
    if (updatePasswordEl.value != updatePassword2El.value) {
        if (updateErrorEl)
            updateErrorEl.show("table-row");
        return;
    }
    if (updateErrorEl)
        updateErrorEl.hide();

    updateErrorEl = $("passStrengthError");
    if ((typeof Librarian.passwordStrengthRegex == "string") && (Librarian.passwordStrengthRegex.length > 0)) {
        var match = new RegExp(Librarian.passwordStrengthRegex).test(updatePasswordEl.value);
        if (!match) {
            if (updateErrorEl)
                updateErrorEl.show("table-row");
            return;
        }
    }
    else if (Librarian.profile.enforcePasswordComplexity) {
        var validationResult = Librarian.Utils.validatePasswordComplexity(updatePasswordEl.value);
        renderPasswordComplexity(validationResult.result);

        if (!validationResult.validPassword) {
            return;
        }
    }
    if (updateErrorEl)
        updateErrorEl.hide();

    // Check existance of security Q&A
    var securityQuestionEl = $("securityQuestion"),
        securityAnswerEl = $("securityAnswer"),
        securityEmptyEl = $("securityError");

    // Make sure that the security question and answe were filled out
    if ((securityAnswerEl.value.length == 0) || (securityQuestionEl.value.length == 0)) {
        securityEmptyEl.show();
        return;
    }
    securityEmptyEl.hide();

    // Hide the error message again so that the
    // user knows if the update fails multiple times.
    updateErrorEl = $("updateError");
    if (updateErrorEl)
        updateErrorEl.hide();

    disableForm(changePassFormEl, true);

    var session = new Librarian.Session();
    session.onUpdateComplete = onUpdatePasswordSuccess;
    session.onFailure = onUpdatePasswordFailure;

    var loginFormEl = $("loginForm");
    session.changePassword(loginFormEl.password.value, updatePasswordEl.value, securityQuestionEl.value, securityAnswerEl.value);
};

onUpdatePasswordSuccess = function() {
    loadLibraryPage();
};

onUpdatePasswordFailure = function() {
    // Display the error message
    var itemEl = $("updateError");
    if (itemEl)
        itemEl.show("table-row");

    disableForm(changePassFormEl, false);
};

// #endregion

// #region Forgot Password

setupForgotPass = function() {
    var forgotPassEl = $("forgotPass");
    if (!forgotPassEl)
        return;

    forgotPassEl.addOnClick(onClickForgotPass);
}

onClickForgotPass = function() {
    var loginFormEl = $("loginForm"),
        username = loginFormEl.email.value;

    clearErrors();

    if (!username) {
        toggleError("resetNoUserError", true);
        return;
    }

    var session = new Librarian.Session();

    session.sendResetPassword(username);
}

// #endregion

// #region User Agreement

setupUserAgreement = function() {
    var agreeEl = $("agreeDiv");
    if (!agreeEl)
        return;

    var agreeButton = $("agreeButton");
    if (agreeButton)
        agreeButton.addOnClick(agree);

    var cancelAgreeButton = $("cancelAgreeButton");
    if (cancelAgreeButton)
        cancelAgreeButton.addOnClick(cancelAgree);
}

checkUserAgreement = function(forceAgree) {
    var agreeEl = $("agreeDiv");
    if (!agreeEl)
        return true;

    if (forceAgree)
        return true;

    var hasAgreed = Librarian.Utils.getUserSetting(agreeSetting);
    var isExpired = false;

    if (Librarian.agreeStateExpDays) {
        isExpired = Librarian.Utils.getUserSetting(agreeSettingExp);
        isExpired = Librarian.Utils.getUTCDateValue(isExpired) < Librarian.Utils.getUTCDateValue(new Date());
    }
    
    if (hasAgreed && !isExpired)
        return true;

    if (typeof loadAgreementPage === "function")
        loadAgreementPage();
    else
        agreeEl.show();

    var itemEl = $("loginForm");
    if (itemEl)
        itemEl.hide();

    itemEl = $("resetPassPanel");
    if (itemEl)
        itemEl.hide();

    itemEl = $("changePassPanel");
    if (itemEl)
        itemEl.hide();

    itemEl = $("passComplexity");
    if (itemEl)
        itemEl.hide();

    return false;
}

agree = function() {
    if (Librarian.saveAgreeState)
        Librarian.Utils.setUserSetting(agreeSetting, true);
    if (Librarian.agreeStateExpDays) {
        var expire = new Date();
        expire.setDate(expire.getDate() + Librarian.agreeStateExpDays);
        Librarian.Utils.setUserSetting(agreeSettingExp, expire);
    }

    loadLibraryPage(true);
};

cancelAgree = function () {
    var itemEl = $("agreeDiv");
    if (itemEl) {
        itemEl.hide();
    }

    var loginFormEl = $("loginForm");
    if (loginFormEl) {
        loginFormEl.show();

        disableForm(loginFormEl, false);
    }
};

// #endregion

// #region Password Complexity

getPasswordComplexityRules = function () {
    var directory = Librarian.profile.customPasswordComplexity ? Librarian.path.getLibraryPath() : Librarian.path.getLayoutsPath() +
        "core/";
    var url = directory  + "passwordcomplexity.json";
    new Request.JSON({
        method: "get",
        url: url,
        noCache: true,
        onSuccess: function (data) {
            if (data) {
                Librarian.passwordComplexityRules = data;
                renderPasswordComplexity(Librarian.passwordComplexityRules);
            }
        },
        onFailure: function (err) {
            console.log(err);
        }
    }).send();

    /*
    var url = Librarian.path.getConfigUrl("getpasscomplexityrules") + "&out=cjson";
    new Request.JSON({
        method: "get",
        url: url,
        noCache: true,
        onSuccess: function (data) {
            if (data) {
                Librarian.passwordComplexityRules = data;
                renderPasswordComplexity($("resetPasswordRequirements"), Librarian.passwordComplexityRules);
                renderPasswordComplexity($("changePasswordRequirements"), Librarian.passwordComplexityRules);
            }
        },
        onFailure: function (err) {
             console.log(err);
        }
    }).send();*/
}

renderPasswordComplexity = function (validationResult) {
    var errorEl = $("passwordRequirements");

    if (errorEl == null) {
        var passwordComplexityRequirementsEl = new Element("div", {
            "id": "passwordRequirementsWrapper"
        });

        passwordComplexityRequirementsEl.set("html",
            "<div class='passwordRequirementsLabel'>\
                Password Requirements:\
            </div>\
            <div id='passwordRequirements'></div>");

        var forgotPassEl = $(document.body).getElement(".forgotpass");
        passwordComplexityRequirementsEl.injectAfter(forgotPassEl);

        errorEl = $("passwordRequirements");
    }

    var rulesEl = new Element("ul", {
        class: "password-complexity-rules"
    });

    validationResult.forEach(function (ruleResult) {
        var ruleEl = new Element("li", {
            class: "password-complexity-rule",
        });
        var stateEl = new Element("span", {
            class: "password-complexity-state"
        });
        var textEl = new Element("span", {
            class: "password-complexity-rule-label",
            text: ruleResult.label
        });
        ruleEl.grab(stateEl);
        ruleEl.grab(textEl);

        if (ruleResult.success === true) {
            stateEl.addClass("success");
        }
        else if (ruleResult.success === false) {
            stateEl.addClass("fail");
        }

        rulesEl.grab(ruleEl);
    });

    if (errorEl) {
        errorEl.empty();
        errorEl.grab(rulesEl);
        errorEl.show();
    }
}

// #endregion

// #region Helpers

disableForm = function(id, disabled) {
    var formEl = $(id);
    if (!formEl)
        return;

    formEl.toggleClass("disabled", disabled);

    var inputEls = formEl.getElements("input");

    inputEls.forEach(function(inputEl) {
        inputEl.disabled = disabled;
    });
}

toggleError = function(id, show) {
    var errorEl = $(id);
    if (!errorEl)
        return;

    errorEl.toggle(show);

    if (show) {
        var wrapperEl = $("errorWrapper");
        if (wrapperEl)
            wrapperEl.show();
    }
};

clearErrors = function() {
    toggleError("passError", false);
    toggleError("badUserError", false);
    toggleError("resetNoUserError", false);
    toggleError("resetSuccess", false);

    var itemEl = $("errorWrapper");
    if (itemEl)
        itemEl.hide();
}

// #endregion

// If the library is set to force secure but it's not currently secure, redirect to the HTTPS page
if (Librarian.forceSecure && !Librarian.secure)
    window.open(window.location.href.replace("http:", "https:"), "_self");

if (!Librarian.newLoginStyle) {
    // Load these styles so the login screen gets adapted to the new styles
    if (Librarian.features.metroui.load)
        Librarian.addStyle(Librarian.path.getDefaultThemePath() + "css/Metro.css");
    if (Librarian.features.darkui.load)
        Librarian.addStyle(Librarian.path.getDefaultThemePath() + "css/Dark.css");
}

Librarian.addStyle(Librarian.path.getDefaultThemePath() + "css/PasswordComplexity.css");
